import { Component, Input } from '@angular/core';
import { ColumnComponent } from '../column/column.component';

@Component({
  selector: 'app-sortable-cell',
  templateUrl: './sortable-cell.component.html',
  styleUrls: ['./sortable-cell.component.css']
})
export class SortableCellComponent {
  @Input() column: ColumnComponent;
  @Input() element: any;

  get value() {
    return (this.element && this.column && this.column.property) ? this.element[this.column.property] : null;
  }

  get boolean() {
    return (this.element && this.column && this.column.booleanColumn) ? true : false;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/shared/components/tables/sortable-table/sortable-cell/sortable-cell.component.ts